import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import firebase from '../Firebase'
import fire from '../Firebase';


class List extends Component {
  constructor(props) {
    super(props);
    this.ref = firebase.firestore().collection('tutorials');
    this.unsubscribe = null;
    this.state = {
      tutorials: [],
      logout: null

    };
  }

  logout() {
    fire.auth().signOut();
  }

  onCollectionUpdate = (querySnapshot) => {
    const tutorials = [];
    querySnapshot.forEach((doc) => {
      const { tutor, learner, school, content, subject, rating } = doc.data();
      tutorials.push({
        key: doc.id,
        doc, // DocumentSnapshot
        tutor,
        learner, 
        subject,
        content,
        school,
        rating
      });
    });
    this.setState({
      tutorials
   });
  }


  componentDidMount() {
    this.unsubscribe = this.ref.onSnapshot(this.onCollectionUpdate);
  }

  render() {
    return (
      <div>
        <nav class="navbar navbar-dark bg-primary">
             <h3  class="navbar-brand mb-0 h1">Tutorial Session Records</h3><br></br>
             <div>
             <button class="btn btn-light"><Link to="/create">Add Tutorial Session</Link></button>  
             <button class="btn btn-dark"><Link to="/">LOG OUT</Link></button>
             </div>
             
             
            </nav> <br></br>
         <div  class="container">  
                  <div class="panel panel-default">
                    
                    <div class="panel-body">
                      
                      <table class="table table-bordered table-dark">
                        <thead class="bg-primary">
                          <tr>
                            <th>Tutor</th>
                            <th>Learner</th>
                            <th>Subject</th>
                            <th>Content</th>
                            <th>School</th>
                            <th>Rating</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.tutorials.map(tutorial =>
                            <tr>
                              <td><Link to={`/show/${tutorial.key}`}>{tutorial.tutor}</Link></td>
                              <td>{tutorial.learner}</td>
                              <td>{tutorial.subject}</td>
                              <td>{tutorial.content}</td>
                              <td>{tutorial.school}</td>
                              <td>{tutorial.rating}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  </div> 
    
      </div>
    );
  }
}

export default List;